import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./ChatbotWidget.scss";

const CHATBOT_URL = "https://d1x8svzs28gqii.cloudfront.net";
const CHATBOT_ORIGIN = "https://d1x8svzs28gqii.cloudfront.net";

const HIDDEN_PATHS = ["/login", "/dev/login", "/cLogin", "/register"];

const ChatbotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleMessage = (event) => {
      // Only accept messages from chatbot
      if (event.origin !== CHATBOT_ORIGIN) {
        return;
      }

      console.log("[ChatbotWidget] Message:", event.data);

      // Chatbot OPEN
      if (event.data?.open === true) {
        console.log("[ChatbotWidget] 🟢 OPEN");
        setIsOpen(true);
      }

      // Chatbot CLOSE
      if (event.data?.open === false) {
        console.log("[ChatbotWidget] 🔴 CLOSE");
        setIsOpen(false);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const isHidden = HIDDEN_PATHS.some((path) =>
    location.pathname.startsWith(`${process.env.PUBLIC_URL}${path}`),
  );

  if (isHidden) {
    return null;
  }

  const iframeClass = isOpen
    ? "chatbot-widget-frame chatbot-widget-frame--open"
    : "chatbot-widget-frame chatbot-widget-frame--closed";

  return (
    <>
      <iframe
        title="KB Chatbot"
        src={CHATBOT_URL}
        className={iframeClass}
        allow="clipboard-write"
      />

      {isOpen && (
        <button
          type="button"
          className="chatbot-widget-close-btn"
          aria-label="Close chatbot"
          onClick={() => setIsOpen(false)}
        >
          ×
        </button>
      )}
    </>
  );
};

export default ChatbotWidget;
